const styles = theme => ({
  value: theme.mixins.gutters({
    margin: 0,
    fontWeight: 200
  }),
  graphHeader:{
    textAlign:'left',
    paddingLeft:75,
  }
})

export default styles
